import { render, staticRenderFns } from "./retailer-new.vue?vue&type=template&id=495e2546"
import script from "./retailer-new.vue?vue&type=script&lang=js"
export * from "./retailer-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports